function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/

import ScrollDir from "scrolldir";
import ScrollLocker from '../classes/scroll-locker';
import ScrollController from '../classes/scroll-control';

/*------------------------------------------------------------------
Scroll Direction
------------------------------------------------------------------*/

ScrollDir();

/*------------------------------------------------------------------
Scroll Controller
------------------------------------------------------------------*/

window.ScrollLocker = new ScrollLocker(document.querySelector('.body'));
window.ScrollController = new ScrollController();
window.ScrollLocker.lock();

/*------------------------------------------------------------------
Scroll to links
------------------------------------------------------------------*/

var links = _toConsumableArray(document.querySelectorAll('a'));
var wrapper = document.body;
wrapper.scrollTo(0, 0);
links.forEach(function (link) {
  if (link.hash) {
    // Find the target element
    var target = document.getElementById(link.hash.replace('#', ''));

    // If the target element exists
    if (target) {
      var element = target.firstElementChild || target;
      // Add the click event listener
      link.addEventListener('click', function (e) {
        e.preventDefault();
        window.ScrollController.Meteora.scrollTo(offset(element).y - 200);
      });
    }
  }
});

// If there is a hash in the URL
if (window.location.hash) {
  var target = document.getElementById(window.location.hash.replace('#', ''));
  var element = target.firstElementChild || target;
  window.scrollTo(0, 0);
  setTimeout(function () {
    // Scroll to the target element
    window.ScrollController.scrollTo(offset(element).y - 200);
  }, 500);
}